import { publishGa4Events } from '@porterin/component-library/src/ts-utils/analytics/react-ga/EventTracker';
import Link from 'next/link';
import React from 'react';

import * as HomeStoreEn from '../../../../containers/home/domain/store/HomeStoreEn.mjs';
import * as PageviewStore from '../../../../containers/fare-estimate-v1/domain/store/PageviewStore.mjs';
import { FooterLinks } from '../../view-model/types/FooterTypes';
import styles from '../styles/Footer.module.scss';

const GA_FOOTER_EVENT_PREFIX: string = PageviewStore.ga_footer_event_prefix;
const GA_FOOTER_LINK_ACTION: string =
  HomeStoreEn.ga_footer_specific_link_action;

interface FooterLinkSectionCmpProps {
  className: string;
  content: FooterLinks;
  query_params: string;
}

function FooterLinkSectionCmp({
  className,
  content,
  query_params,
}: Readonly<FooterLinkSectionCmpProps>): React.ReactElement {
  return (
    <div className={className}>
      <div className={styles['title']}>{content.title}</div>
      <div className={styles['list']}>
        {content.links.map(footer_link => (
          <Link
            key={footer_link.title}
            href={footer_link.link + query_params}
            prefetch={false}
            target="_parent"
            onClick={(): void => {
              publishGa4Events(
                GA_FOOTER_EVENT_PREFIX,
                GA_FOOTER_LINK_ACTION +
                  (footer_link.title === 'Driver Partner Terms & Conditions'
                    ? 'Driver Partner T&C'
                    : footer_link.title),
                footer_link.title,
              );
            }}
          >
            <div className={styles['list-item']}>{footer_link.title}</div>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default FooterLinkSectionCmp;
